export const price = value => `£${value}`;



// WEBPACK FOOTER //
// ./app/javascript/components/brief/utils/format.js